import React from 'react';
import { MinimumPrivacy } from 'app/pages/Profile/MinimumPrivacy';

export const MinimumPrivacyModal: React.FC = props => (
  <MinimumPrivacy {...props} />
);
